<template>
    <v-layout row fill-height align-center justify-center style="width:100%">
        <v-flex md12 lg10>
            <v-card class="pa-4" v-if="!selectedPoll.completed">
                <v-progress-linear v-model="selectedPoll.progression" class="my-0"></v-progress-linear>
                <v-container
                    fluid
                    grid-list-xs
                >
                    <v-layout row>
                        <v-flex xs12>
                            <div v-if="selectedPoll.score.instructions">
                                <h3 v-html="selectedPoll.score.instructions" class="font-weight-regular"></h3>
                                <v-divider class="my-4"></v-divider>
                            </div>
                            <div v-if="question.group.name">
                                <h3>{{ question.group.name}}</h3>
                                <p v-html="question.group.instructions"></p>
                            </div>
                        </v-flex>

                    </v-layout>

                    <v-layout align-center justify-center row v-if="!question.special_type">
                        <v-flex xs12 sm8 offset-sm2>
                            <h2 class="my-4 question-title" v-html="question.text"></h2>
                            <div class="custom-radio">
                                <div class="radio mb-2"
                                     v-for="answer in question.answers"
                                     :key="answer.id">
                                    <input type="radio" name="answer" :value="answer.id" v-model="response" :disabled="markAsDisabled"
                                           @change="sendAnswer()"
                                           :id="'answer'+answer.id">
                                    <label class="v-label theme--light" :for="'answer'+answer.id">{{answer.text}}<span
                                        v-if="answer.remarks" v-html="'<br>' + answer.remarks"></span></label>
                                </div>
                            </div>
                        </v-flex>
                        <v-spacer></v-spacer>
                    </v-layout>

                    <v-layout align-center justify-center row v-else-if="question.special_type === 'scale_custom'">
                        <v-flex xs12 sm10 offset-sm1>
                            <h2 class="my-4 question-title" v-html="question.text"></h2>

                            <v-layout row>
                                <v-flex xs12>
                                    <div class="v-input mb-4">
                                        <div class="v-input__prepend-outer">{{ question.answers[0].text }}</div>
                                        <vue-slider
                                            class="v-input__control"
                                          v-model="multi_slider_value"
                                          :dot-options="dotOptions"
                                          :data="dataForQuestion(question)"
                                          :marks="false"
                                          :order="false"
                                          :tooltip="'none'"
                                          @change="updateSliderResponse()"
                                         :disabled="markAsDisabled"
                                        ></vue-slider>
                                        <div class="v-input__append-outer">{{ question.answers[question.answers.length -1].text }}</div>
                                    </div>

                                </v-flex>
                            </v-layout>
                        </v-flex>
                        <v-spacer></v-spacer>
                    </v-layout>

                    <v-layout align-center justify-center row v-else-if="question.special_type === 'scale'">
                        <v-flex xs12 sm10 offset-sm1>
                            <h2 class="my-4 question-title" v-html="question.text"></h2>

                            <v-layout>
                                <v-flex xs12>
                                    <v-slider
                                    :min="0"
                                    :max="question.answers.length - 1"
                                    ticks
                                    always-dirty
                                    v-model="slider_value"
                                    :tick-labels="getTicksLabels()"
                                    @change="updateResponse()"
                                    :disabled="markAsDisabled"
                                    tick-size="0"
                                    thumb-label="always"
                                    class="mb-4">
                                        <template v-slot:prepend>
                                            {{ question.answers[0].remarks }}
                                        </template>
                                        <template v-slot:thumb-label="props">
                                          <span>
                                            {{ question.answers[props.value].value }}
                                          </span>
                                        </template>
                                        <template v-slot:append>
                                            {{ question.answers[question.answers.length - 1].remarks }}
                                        </template>
                                    </v-slider>
                                </v-flex>

                            </v-layout>

                        </v-flex>
                        <v-spacer></v-spacer>
                    </v-layout>

                    <v-layout align-center justify-center row v-else-if="question.special_type === 'scale_no_label'">
                        <v-flex xs12 sm10 offset-sm1>
                            <h2 class="my-4 question-title" v-html="question.text"></h2>

                            <v-layout>
                                <v-flex xs12>
                                    <v-slider
                                        :min="0"
                                        :max="question.answers.length - 1"
                                        ticks
                                        always-dirty
                                        v-model="slider_value"
                                        @change="updateResponse()"
                                        :disabled="markAsDisabled"
                                        tick-size="0"
                                        class="mb-4">
                                        <template v-slot:prepend>
                                            {{ question.answers[0].remarks }}
                                        </template>
                                        <template v-slot:thumb-label="props">
                                          <span>
                                            {{ question.answers[props.value].text ? question.answers[props.value].text : question.answers[props.value].value }}
                                          </span>
                                        </template>
                                        <template v-slot:append>
                                            {{ question.answers[question.answers.length - 1].remarks }}
                                        </template>
                                    </v-slider>
                                </v-flex>

                            </v-layout>

                        </v-flex>
                        <v-spacer></v-spacer>
                    </v-layout>
                    <v-layout align-center justify-center row v-else-if="question.special_type === 'scale_degree'">
                        <v-flex xs12 sm10 offset-sm1>
                            <h2 class="my-4 question-title" v-html="question.text"></h2>

                            <v-layout>
                                <v-flex xs12>
                                    <v-slider
                                        :min="0"
                                        :max="question.answers.length - 1"
                                        ticks
                                        always-dirty
                                        v-model="slider_value"
                                        :tick-labels="getTicksLabels()"
                                        @change="updateResponse()"
                                        :disabled="markAsDisabled"
                                        tick-size="0"
                                        class="mb-4">
                                    </v-slider>
                                </v-flex>

                            </v-layout>

                        </v-flex>
                        <v-spacer></v-spacer>
                    </v-layout>

                    <v-layout align-center justify-center row v-else-if="question.special_type === 'scale_select_degree'">
                        <v-flex xs12 sm10 offset-sm1>
                            <h2 class="my-4 question-title" v-html="question.text"></h2>

                            <v-layout>
                                <v-flex xs12>
                                    <v-select
                                        v-model="slider_value"
                                        :items="question.answers"
                                        @change="updateResponse()"
                                        :disabled="markAsDisabled"
                                    ></v-select>
                                </v-flex>

                            </v-layout>

                        </v-flex>
                        <v-spacer></v-spacer>
                    </v-layout>

                    <v-layout align-center justify-center row v-if="!question.special_type">
                        <v-flex xs3 text-xs-left>
                            <v-btn text color="primary" @click="removeLast()">
                                {{ $t('previous')}}
                            </v-btn>
                        </v-flex>
                        <v-flex xs3 offset-xs3 text-xs-right>
                            <v-btn v-if="response && false" text color="primary" @click="sendAnswer()">
                                {{ $t('next')}}
                            </v-btn>
                        </v-flex>
                    </v-layout>

                    <v-layout align-center justify-center row v-else>
                        <v-flex xs3 text-xs-left>
                            <v-btn text color="primary" @click="removeLast()">
                                {{ $t('previous')}}
                            </v-btn>
                        </v-flex>
                        <v-flex xs3 offset-xs3 text-xs-right>
                            <v-btn text color="primary" @click="sendAnswer()">
                                {{ $t('next')}}
                            </v-btn>
                        </v-flex>
                    </v-layout>

                </v-container>
            </v-card>
            <v-card v-else class="pa-4">
                <v-card-title>
                    <v-layout column mt-4>
                        <v-flex pa-2>
                            <h2>{{$t('followUpCompleted')}}</h2>
                        </v-flex>
                        <v-flex px-2>
                            <span class="title">{{$t('followUpCompletedMessage')}}</span>
                            <p v-if="completedNextUrl">
                                {{$t('followUpCompletedNextMessage')}}<br>
                                <a :href="completedNextUrl">{{$t('followUpCompletedNextMessageClickHere')}}</a>
                            </p>
                        </v-flex>
                    </v-layout>
                </v-card-title>
            </v-card>
        </v-flex>
    </v-layout>
</template>

<script>
    import {mapActions, mapState, mapMutations} from 'vuex'
    import VueSlider from 'vue-slider-component'
    import 'vue-slider-component/theme/default.css'

    export default {
        name: "PatientPollScoreView",
        components: {
            VueSlider
        },
        data() {
            return {
                response: null,
                btn_next: false,
                slider_value: 0,
                multi_slider_value: [0,0],
                dotOptions: [{
                  disabled: false
                }, {
                  disabled: true
                }],
                markAsDisabled: false
            }
        },
        mounted() {
            this.getNextQuestionFromNotification().then(result => {
                this.initResponse(result)
            }).catch(reason => {
                //Stay here..
            })

        },
        computed: {
            ...mapState('polls', {
                selectedPoll: state => state.selectedPoll,
                question: state => state.question,
                completedNextUrl: state => state.completedNextUrl,
            })

        },
        methods: {
            ...mapMutations('polls', [
                'setSelectedPollId',
                'setCompletedNextUrl'
            ]),
            ...mapActions('polls', [
                'getNextQuestionFromNotification',
                'updateQuestionFromNotification',
                'removeLastAnswerFromNotification'
            ]),
            initResponse(result) {
                this.response = null;
                this.btn_next = false
                this.slider_value = 0
                this.multi_slider_value = [0,0]

                if (this.question !== null) {
                    if (this.question.special_type) {
                        if (this.question.special_type === 'scale_custom') {
                            this.multi_slider_value = [Math.round(result.data.question.answers.length / 2) - 1, Math.round(result.data.question.answers.length / 2) - 1];
                            this.response = this.question.answers[this.multi_slider_value[0]].id
                        }
                        else {
                            this.slider_value = 0
                            this.response = this.question.answers[this.slider_value].id
                        }
                    }
                }
                else {

                    if (this.completedNextUrl) {
                        setTimeout(this.redirectToNext,5000)
                    }
                }
            },
            getTicksLabels() {

                if (this.question.answers != null) {
                    return this.question.answers.map(answer => answer.text)
                }
                return []
            },
            updateResponse() {
                if (this.slider_value != null) {
                    this.response = this.question.answers[this.slider_value].id
                }
            },
            updateSliderResponse() {
                if (this.multi_slider_value != null) {
                    this.response = this.question.answers[this.multi_slider_value[0]].id
                }
            },
            dataForQuestion(question) {
                return question.answers.map((item, index) => index)
            },
            sendAnswer() {
                this.markAsDisabled = true
                this.$nextTick(function () {
                    setTimeout(() => {

                        console.log(this.response);

                        if (this.response !== null) {
                            this.updateQuestionFromNotification({score_question_answer_id: this.response}).then(result => {

                                this.setCompletedNextUrl(result.data.next_link)
                                this.initResponse(result)
                                this.markAsDisabled = false

                            }).catch(reason => {
                                //Stay here..
                                console.log(reason)
                                this.markAsDisabled = false
                            })
                        }
                    }, 150);
            })

            },
            removeLast() {
                this.removeLastAnswerFromNotification().then(response => {
                    this.initResponse(response)

                }).catch(reason => {
                    //Stay here..
                })

            },
            back() {
                this.$router.back()
            },
            formatAnswer(text, remark) {
                if (remark !== null) {
                    return text + " - " + remark
                }
                return text
            },

            redirectToNext() {
                window.location.href = this.completedNextUrl
            }
        }
    }
</script>

<style scoped>
    .height-max {
        height: 100%;
        overflow: hidden;
    }


</style>
